module.exports = __webpack_public_path__ + "e31213101cc8878c60da438e1311cee6.png";